import globalTheme from '../../global'

const Radio = {
	MuiRadio: {
		defaultProps: {
			disableRipple: true,
		},
		styleOverrides: {
			root: {
				color: globalTheme.palette.grey.light,
				padding: 0,
				'&:focus': {
					color: globalTheme.palette.grey.main,
				},
				'&:hover': {
					color: globalTheme.palette.grey.medium,
				},
				'&.Mui-disabled': {
					color: globalTheme.palette.grey.light,
				},
				'&.Mui-checked': {
					color: globalTheme.palette.primary.main,
					'&:focus': {
						color: globalTheme.palette.grey.main,
					},
					'&:hover': {
						color: globalTheme.palette.grey.medium,
					},
				},
			},
		},
	},
}

export default Radio
